export default __webpack_public_path__ + "static/media/xml.6bd9b73e.svg";